const slackSettingMetaInfo = {
    meta: {
        columns: [
            {
                datatype: 'string',
                description: 'Webhook Name',
                label: 'Name',
                'min-width': 100,
                name: "webhook_name",
                sortable: false
            },
            {
                datatype: 'string',
                description: 'webhook URL',
                label: 'URL',
                'min-width': 200,
                name: 'webhook_url',
                sortable: false
            }
        ]
    }
}

export { slackSettingMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/slack/slack-setting-meta.js